const portalUrl = '';

const authorizedFetch = async (url) => {
  if (!window.Liferay) {
    throw new Error("Liferay session not available");
  }

  const response = await fetch(url, {
    credentials: "include",
    headers: {
      "X-CSRF-Token": window.Liferay?.authToken,
      "Content-Type": "application/json",
      Accept: "application/json"
    },
  });
  if (!response.ok) {
    const text = await response.text();
    console.error("API ERROR:", response.status, text);
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};
export const getATMStates = async () => {
  const url = `${portalUrl}/o/c/atmlocatorstates/?fields=stateName&pageSize=50&page=1`;

  const data = await authorizedFetch(url);

  const stateMap = new Map();

  data.items.forEach(item => {
    const rawState = item.stateName; 
    if (!rawState) return;

    const normalized = rawState.trim().toUpperCase();

    if (!stateMap.has(normalized)) {
      stateMap.set(normalized, rawState.trim());
    }
  });

  return Array.from(stateMap.values()).sort();
};



export const getATMDistricts = async (state) => {
  if (!state) return [];

  const filter = encodeURIComponent(`stateName eq '${state}'`);

  const url =
    `${portalUrl}/o/c/atmlocatordistricts/` +
    `?fields=district&filter=${filter}&page=1&pageSize=75`;

  const data = await authorizedFetch(url);

  const districtMap = new Map();

  data.items.forEach(item => {
    const rawDistrict = item.district;
    if (!rawDistrict) return;

    const normalized = rawDistrict.trim().toUpperCase();

    if (!districtMap.has(normalized)) {
      districtMap.set(normalized, rawDistrict.trim());
    }
  });

  return Array.from(districtMap.values()).sort();
};



export const searchATMs = async (
  state,
  district,
  branch,
  page = 1,
  pageSize = 10
) => {

  const filters = [];

  if (state) filters.push(`state eq '${state}'`);
  if (district) filters.push(`district eq '${district}'`);
  if (branch && branch !== "All")
    filters.push(`branchName eq '${branch}'`);

  const filterString = filters.length
    ? `&filter=${encodeURIComponent(filters.join(" and "))}`
    : "";

  const url =
    `${portalUrl}/o/c/atmlocators` +
    `?page=${page}&pageSize=${pageSize}${filterString}`;

  return await authorizedFetch(url);
};
